// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import React from 'react';
import { useAppDispatch, useAppSelector } from 'Hooks';
import { InlineNameEditor } from 'Components/InlineNameEditor';
import { getOrders } from 'Features/order/orderSelectors';
import { UpdateProjectNameThunk } from 'Features/project/projectThunk';

interface ComponentProps {
  initialProjectName: string;
  projectId: string;
}

export const ProjectName: React.FC<ComponentProps> = ({ initialProjectName, projectId }) => {
  const dispatch = useAppDispatch();
  const { projectOrders } = useAppSelector((state) => getOrders(state));

  // Renaming is allowed once the orders are known and none of them has been placed
  const canEdit = projectOrders.length > 0 && !projectOrders.some((order) => order.orderStatus > 0);

  return (
    <InlineNameEditor
      name={initialProjectName}
      ariaLabel="Project Name"
      canEdit={canEdit}
      fallbackError="Failed to rename project"
      onSave={(name) => dispatch(UpdateProjectNameThunk({ _id: projectId, name }))}
    />
  );
};

export default ProjectName;
